import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import { FrontUrls } from 'Constants/FrontUrls'
import { ErrorPage } from './ErrorPage'

export const Page_404Component: FC = () => {
	const history = useHistory()

	useEffectOnce(() => {
		history.replace(FrontUrls.pages.page_404)
	})

	return (
		<ErrorPage
			advice="Перейдите на стартовую страницу, чтобы попробовать ещё раз или обратитесь в&nbsp;поддержку."
			errorCode={404}
			title="Что-то пошло не так..."
		/>
	)
}
